import { useEffect, useState } from "react";
import { Microphone } from "@phosphor-icons/react";
import { kioskApi, isKioskDevice } from "@/lib/kioskApi";

// Shown on the ORIGINAL touchscreen kiosk only on an authorised AI-kiosk device while AI ordering is ON.
export function AiCashierLink() {
  const [on, setOn] = useState(false);
  useEffect(() => {
    if (!isKioskDevice()) return;
    kioskApi.get("/bootstrap").then((r) => setOn(!!r.data.customer_ai_enabled && !!r.data.budget?.ai_available)).catch(() => setOn(false));
  }, []);
  if (!on) return null;
  return (
    <a href="/kiosk" data-testid="co-ai-cashier-link"
      className="px-5 h-12 rounded-full bg-[var(--terracotta)] text-white text-base font-medium inline-flex items-center gap-2 active:scale-95 transition-transform">
      <Microphone size={18} weight="fill" /> Talk to our AI cashier
    </a>
  );
}
